const initialState = {
  listAllIdeb: [],
  detailNasabahIdeb: true,
};

const informasiDebiturReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "GET_ALL_DATA_IDEB":
      return {
        ...state,
        listAllIdeb: data,
      };
    case "SET_DETAIL_NASABAH_IDEB":
      return {
        ...state,
        detailNasabahIdeb: data,
      };
    default:
      return state;
  }
};

export default informasiDebiturReducer;
